import React from "react";
import { HeroRangeSelect } from "../../../shared/components/HeroRangeSelect/HeroRangeSelect";
import {
  isDefaultBookkeepingRange,
  useBookkeepingDateRange
} from "./useBookkeepingDateRange";

export const BookkeepingRangeSelect: React.FC = () => {
  const { range, setRange } = useBookkeepingDateRange();

  return (
    <HeroRangeSelect
      position="right"
      value={[range.start, range.end]}
      customLabel={
        isDefaultBookkeepingRange(range)
          ? String(range.start.getFullYear())
          : undefined
      }
      onChange={option =>
        setRange({ start: option.value[0], end: option.value[1] })
      }
    />
  );
};
